module.exports = __webpack_public_path__ + "static/media/ConcaDS.8944a1ec.jpg";